import { PoolData } from "../../model/poolData";
import { getStrokeColorIndex } from "../../pages/pool/PoolProcessor";
import { fetchGetJSON } from "../api-helpers";
import { apiUrls } from "../constants";

type DtoType = PoolData;

type FetchResponseType = {
  data?: DtoType[];
  error?: string;
};

export type TransformedDataType = DtoType & { availablePercentageX: string };

export type ResponseGuiType = {
  data?: TransformedDataType[];
  error?: string;
};

export async function getPoolsData(): Promise<ResponseGuiType> {
  console.log("getPoolData() API called");
  try {
    const response: FetchResponseType = await fetchGetJSON(
      apiUrls.getPoolsData
    );
    if (response.error) {
      return { error: response.error };
    } else if (response.data) {
      const transformedResponse = response.data.map((item) => {
        //availablePercentageX is a string with the format "colorIndex:percentage"
        //This is to support sorting feature, first by color, then percentage.
        const strokeColorIndex = getStrokeColorIndex(
          item.availableCount,
          item.threshold
        );
        const availablePercentageX = `${strokeColorIndex}:${Number(item.availablePercentage).toFixed().padStart(3, "0")}`;
        return {
          ...item,
          availablePercentageX,
        };
      });

      return { data: transformedResponse };
    }
    return { error: "invariant violation" };
  } catch (err) {
    console.error("Error fetching Pool data:", err);
    return { error: (err as Error).message };
  }
}
